import { connect } from "react-redux";
import TableHeaderComponent from "../../../Components/RecordingComponent/TableComponent/TableHeaderComponent";
const mapStateToProps = (state) => ({
    callFlows: state.reducer.callFlows,
    supervisedAgentDetails: state.reducer.supervisedAgentDetails,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableHeaderComponent);
